import _isNumber from 'lodash/isNumber';

function isNumber(value) {
    return _isNumber(value||null);
}

export {isNumber};
